
import { mapGetters } from 'vuex';

export default {
  watch: {
    darkMode(value) {
      this.$vuetify.theme.dark = value;
    },
  },
  methods: {
    handleDarkMode() {
      window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', this.darkModeListener);

      if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
        this.$store.commit('SET_DARK_MODE', true);
      }
    },
    darkModeListener(event) {
      this.$store.commit('SET_DARK_MODE', event.matches);
    },
  },

  computed: {
    ...mapGetters(['darkMode', 'globalLoading']),
  },

  beforeDestroy() {
    window.removeEventListener('change', this.darkModeListener);
  },
  async created() {
    this.handleDarkMode();
  },


};
